import { Box, Tab, Tabs } from "@mui/material";
import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Auth } from "aws-amplify";
import AdminModels from "./AdminModels";
import AdminOpenRouterModels from "./AdminOpenRouterModels";
import AdminProjects from "./AdminProjects";
import AdminLLMTest from "./AdminLLMTest";
import AdminProjectCosts from "./AdminProjectCosts";
import BatchChatTest from "../BatchChatTest";
import AdminPromptCompressionSavings from "./AdminPromptCompressionSavings";
import AdminApiKeyMigration from "./AdminApiKeyMigration";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div role="tabpanel" hidden={value !== index} {...other}>
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

export default function AdminHome() {
  const [value, setValue] = useState(0);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    checkAdminAuth();
    handleUrlParams();
  }, []);

  useEffect(() => {
    // Watch for URL changes (e.g., when navigating with React Router)
    handleUrlParams();
  }, [location]);
  const handleUrlParams = () => {
    // Check URL hash for tab and parameters
    const hash = window.location.hash;
    const search = window.location.search;
    
    console.log('AdminHome - Current URL:', window.location.href);
    console.log('AdminHome - Hash:', hash);
    console.log('AdminHome - Search:', search);
    
    // Handle tab switching based on hash
    if (hash.includes('openrouter-models')) {
      setValue(2); // OpenRouter Models tab
    } else if (hash.includes('models')) {
      console.log('AdminHome - Switching to Models tab');
      setValue(1); // Models tab
    } else if (hash.includes('projects')) {
      setValue(3); // Projects tab
    } else if (hash.includes('project-costs')) {
      setValue(4); // Project Costs tab
    } else if (hash.includes('llmtest')) {
      setValue(5); // LLM Test tab
    } else if (hash.includes('batchtest')) {
      setValue(6); // Batch Test tab
    } else if (hash.includes('compression-savings')) {
      setValue(7); // Compression Savings tab
    } else if (hash.includes('dashboard')) {
      setValue(0); // Dashboard tab
    }
  };

  const checkAdminAuth = async () => {
    try {
      const session = await Auth.currentSession();
      const groups = session.getAccessToken().payload["cognito:groups"] || [];
      if (!groups.includes("llmasaservice-admin")) {
        navigate("/");
      }
    } catch (error) {
      console.error("Auth error:", error);
      navigate("/");
    }
  };

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: "100%", height: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs value={value} onChange={handleChange}>
          <Tab label="Dashboard" />
          <Tab label="Models" />
          <Tab label="OpenRouter Models" />
          <Tab label="Projects" />
          <Tab label="Project Costs" />
          <Tab label="LLM Test" />
          <Tab label="Vendor Batch Test" />
          <Tab label="Compression Savings" />
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        <AdminApiKeyMigration />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <AdminModels />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <AdminOpenRouterModels />
      </TabPanel>
      <TabPanel value={value} index={3}>
        <AdminProjects />
      </TabPanel>
      <TabPanel value={value} index={4}>
        <AdminProjectCosts />
      </TabPanel>
      <TabPanel value={value} index={5}>
        <AdminLLMTest />
      </TabPanel>
      <TabPanel value={value} index={6}>
        <BatchChatTest />
      </TabPanel>
      <TabPanel value={value} index={7}>
        <AdminPromptCompressionSavings />
      </TabPanel>
    </Box>
  );
}
